var _path, _path2, _path3, _path4, _path5;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMembersIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 21,
    viewBox: "0 0 26 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10 20.0456C8.11214 20.0456 6.26662 19.4858 4.69688 18.4369C3.12714 17.3881 1.90367 15.8973 1.1812 14.1531C0.458726 12.4089 0.269694 10.4896 0.638007 8.63795C1.00632 6.78631 1.91544 5.08547 3.25039 3.75052C4.58535 2.41556 6.28619 1.50644 8.13782 1.13813C9.98946 0.769816 11.9087 0.958848 13.6529 1.68132C15.3971 2.40379 16.8879 3.62726 17.9368 5.197C18.9857 6.76674 19.5455 8.61226 19.5455 10.5002C19.5455 13.0318 18.5398 15.4597 16.7497 17.2498C14.9596 19.0399 12.5317 20.0456 10 20.0456V20.0456Z",
    stroke: "#76808D",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.6455 1.01563C12.0046 0.975122 12.3658 0.954788 12.7273 0.954718C15.1559 0.952073 17.4942 1.87525 19.266 3.53625C21.0379 5.19725 22.1099 7.47116 22.2639 9.8949C22.4179 12.3186 21.6423 14.7099 20.0949 16.5818C18.5476 18.4537 16.3449 19.6654 13.9355 19.9702C13.1124 20.0734 12.2796 20.0707 11.4573 19.962",
    stroke: "#76808D",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.1191 1.01563C14.4783 0.975122 14.8394 0.954788 15.2009 0.954718C17.6295 0.952073 19.9679 1.87525 21.7397 3.53625C23.5115 5.19725 24.5836 7.47116 24.7375 9.8949C24.8915 12.3186 24.1159 14.7099 22.5685 16.5818C21.0212 18.4537 18.8185 19.6654 16.4091 19.9702C15.5861 20.0734 14.7532 20.0707 13.9309 19.962",
    stroke: "#76808D",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M13.091 9.23379C13.0911 9.82892 12.9147 10.4107 12.5841 10.9055C12.2534 11.4004 11.7834 11.7859 11.2335 12.0135C10.6836 12.241 10.0785 12.3003 9.49488 12.1838C8.91127 12.0672 8.37535 11.7802 7.95498 11.3589C7.5346 10.9376 7.24867 10.4011 7.13338 9.81725C7.0181 9.23339 7.07864 8.62846 7.30734 8.07903C7.53604 7.52959 7.92262 7.06037 8.41814 6.73077C8.91366 6.40116 9.49583 6.22599 10.091 6.22743C10.887 6.22959 11.6498 6.54723 12.2121 7.11075C12.7745 7.67426 13.0905 8.4377 13.091 9.23379V9.23379Z",
    stroke: "#76808D",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M14.0908 18.7848C14.0555 17.724 13.6092 16.7185 12.8463 15.9806C12.0834 15.2427 11.0636 14.8302 10.0022 14.8302C8.94084 14.8302 7.92102 15.2427 7.15811 15.9806C6.39521 16.7185 5.94895 17.724 5.91357 18.7848",
    stroke: "#76808D",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMembersIcon);
export default __webpack_public_path__ + "static/media/membersIcon.438fb87e82c81da0a43162433fd801f3.svg";
export { ForwardRef as ReactComponent };